export default __webpack_public_path__ + "static/media/shutterstock_1868491405.3282726f.jpg";